import theme from '@/constants/theme';
import { ChoiceQuestion, MultipleChoiceQuestion, Response } from '../../../common';
import CheckboxOption from './CheckboxOption';
import RadioOption from './RadioOption';

interface Props {
  type: ChoiceQuestion['type'];
  questionId: ChoiceQuestion['id'];
  options: ChoiceQuestion['options'];
  response?: Response['answer'];
  config?: ChoiceQuestion['config'];
  onChangeResponse?: (response: Response['answer']) => void;
}

const QuestionOptions = ({ type, questionId, options, response, config, onChangeResponse }: Props) => {
  return (
    <div style={{ display: 'flex', gap: 16, flexDirection: 'column' }}>
      <div style={{ display: 'flex', gap: 8, flexDirection: 'column' }}>
        {type === 'singleChoice' &&
          (options as ChoiceQuestion['options'])?.map((option, index) => (
            <RadioOption
              key={index}
              option={option}
              questionId={questionId}
              response={response as string}
              onChangeResponse={onChangeResponse}
            />
          ))}

        {type === 'multipleChoice' &&
          (options as ChoiceQuestion['options'])?.map((option, index) => (
            <CheckboxOption
              key={index}
              option={option}
              questionId={questionId}
              response={response as string[]}
              onChangeResponse={onChangeResponse}
            />
          ))}
      </div>
      {type === 'multipleChoice' && (config as MultipleChoiceQuestion['config'])?.countSelected && (
        <span style={{ color: theme.colors.text.caption }}>
          Opciones seleccionadas: {(response as MultipleChoiceQuestion['options'])?.length ?? 0}
        </span>
      )}
    </div>
  );
};

export default QuestionOptions;
